import { ReactNode } from 'react';
import { Divider, Stack, Typography } from '@optimus-web/core';

export const PaymentLinkDetailItem = ({ description, value }: { description: ReactNode; value: ReactNode }) => (
    <Stack vertical spacing="200">
        <Stack spacing="200">
            <Typography textStyle="bodyLarge" as="p" variant="secondary">
                {description}
            </Typography>
            {value}
        </Stack>
        <Divider />
    </Stack>
);
